import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module';
export var initializeGa = function (gaTrackingId) {
    try {
        ReactGA.initialize(gaTrackingId);
        return true;
    }
    catch (error) {
        return false;
    }
};
export var initializeGTM = function (gtmTrackingId) {
    try {
        TagManager.initialize({
            gtmId: gtmTrackingId,
        });
        return true;
    }
    catch (error) {
        return false;
    }
};
export var getClientId = function () {
    try {
        var ga = ReactGA.ga();
        // @ts-ignore
        var tracker = ga.getByName('gtm1');
        if (tracker) {
            return tracker.get('dimension1');
        }
        return '000000';
    }
    catch (e) {
        // GA not initialzed yet
        return '000000';
    }
};
